import React, { Suspense, useEffect, useState } from "react";
import {
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  Empty,
  Flex,
  Input,
  Layout,
  notification,
  Row,
  theme,
  Tooltip,
  Typography,
} from "antd";
import {
  FilterOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
// import DashboardMeetings from "./DashboardMeetings";
// import DashboardVotings from "./DashboardVotings";
import { useSelector } from "react-redux";
import MeetingAPI from "../../restAPI/MeetingAPI";
import dayjs from "dayjs";
import CommonSkeletonLoader from "../../helperComponents/CommonSkeleton";
import {connectNotificationSocket, getNotificationSocket} from '../../notificationSocketService';

const DashboardMeetings = React.lazy(() => import("./DashboardMeetings"));
const DashboardVotings = React.lazy(() => import("./DashboardVotings")); 

const { Search } = Input;
const { Header, Footer, Sider, Content } = Layout;
const { Title, Text } = Typography;

export default function Dashboard() {
  const { companyId, token, userCompany, role } = useSelector(
    (state) => state.auth
  );
  const {
    token: { colorBgContainer, borderRadiusLG, colorTextDescription },
  } = theme.useToken();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const [dashboardMeetingList, setDashboardMeetingList] = useState([]);
  const [dashboardVotingList, setDashboardVotingList] = useState([]);
  const [currentDate, setCurrentDate] = useState(null);
  const [sameVoteIndicated, setSameVoteIndicated] = useState(false);
  const [votesLoading, setVotesLoading] = useState(false);
  const [rsvpLoading, setRsvpsLoading] = useState(false);
  const [fullScreenLoading, setFullScreenLoading] = useState(false);
  const [triggerMeetings, setTriggerMeetings] = useState([]);

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
    });
  };

  const getTodayDashboadData = async () => {
    try {
      const response = await MeetingAPI.getMeetingListForDashboard(
        companyId,
        token
      );
      if (response?.data) {
        const todayVotings =
          response.data.votings && response.data.votings.length > 0
            ? response.data.votings.filter((singleVoting) =>
                dayjs(singleVoting.originalDate).isSame(
                  dayjs(response.data.date),
                  "day"
                )
              )
            : [];

        setDashboardMeetingList(response.data.meetings);
        setDashboardVotingList(todayVotings);
        setCurrentDate(response.data.date);
        setVotesLoading(false);
        setRsvpsLoading(false);
        setFullScreenLoading(false);
      } else {
        setDashboardMeetingList([]);
        setDashboardVotingList([]);
        setCurrentDate(null);
      }
    } catch (error) {
      setDashboardMeetingList([]);
      setDashboardVotingList([]);
      setCurrentDate(null);
      setVotesLoading(false);
      setRsvpsLoading(false);
      setFullScreenLoading(false);

      //openNotificationWithIcon("error","Failed to retrieve",`Failed to fetch meeting list for today.`,"bottomLeft");
      console.log("Error in fetching meeting list :", error);
    }
  };

  // useEffect(() => {
  //   if (token && companyId) {
  //     const socket = connectNotificationSocket(token, companyId);

  //     socket.on("connect", () => {
  //       console.log("🔌 Notification socket connected:", socket.id);
  //       socket.emit("notification_join");
  //     });

  //     socket.on("notification_new", (data)=>{
  //       openNotificationWithIcon(
  //         "success",
  //         data.title,
  //         data.body,
  //         "topRight",
  //       );
  //     })

  //     socket.on("connect_error", (err) => {
  //       console.error("❌ Notification socket error:", err.message);
  //     });

  //     // Optional: cleanup on component unmount
  //     return () => {
  //       const existingSocket = getNotificationSocket();
  //       if (existingSocket?.connected) {
  //         existingSocket.disconnect();
  //       }
  //     };
  //   }
  // }, [token, companyId]);


  useEffect(() => {
    if (companyId) {
      setFullScreenLoading(true);
      getTodayDashboadData();
      setTriggerMeetings([]);
    }
  }, [companyId]);

  return (
    <>
      <Flex
        gap={20}
        justify="space-between"
        align="center"
        style={{
          margin: "16px",
          padding: "16px 24px",
          // minHeight: 280,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        <Breadcrumb
          items={[
            {
              // href: '',
              title: <HomeOutlined />,
            },
            {
              title: "Dashboard",
            },
          ]}
        />
      </Flex>
      <div
        style={{
          margin: "16px",
          // padding: 24,
          // minHeight: "78svh",
          // background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        {fullScreenLoading ? (
          <CommonSkeletonLoader />
        ) : (
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Flex
                align="center"
                justify="space-between"
                style={{ padding: "0 0 12px 0" }}
              >
                <Text strong>Meetings</Text>
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() => navigate("/My-calendar")}
                >
                  {" "}
                  View All{" "}
                </Button>
              </Flex>

              {rsvpLoading ? (
                <CommonSkeletonLoader
                  itemCount={
                    dashboardMeetingList ? dashboardMeetingList.length : 3
                  }
                />
              ) : dashboardMeetingList && dashboardMeetingList.length > 0 ? (
                // suspence meeting list with Skeleton loader
                <Suspense fallback={
                  <CommonSkeletonLoader itemCount={dashboardMeetingList ? dashboardMeetingList.length : 3} />
                }>
                  {
                    dashboardMeetingList.map((singleMeeting, index) => (
                      <DashboardMeetings
                        key={singleMeeting._id || index}
                        index={index}
                        singleMeetingFullData={singleMeeting}
                        currentDate={currentDate}
                        getTodayDashboadData={getTodayDashboadData}
                        rsvpLoading={rsvpLoading}
                        setRsvpsLoading={setRsvpsLoading}
                        triggerMeetings={triggerMeetings}
                        setTriggerMeetings={setTriggerMeetings}
                      />
                    ))
                  }
                </Suspense>
              ) : (
                <>
                  <Flex
                    align="center"
                    justify="center"
                    style={{ minHeight: 300 }}
                  >
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={
                        <Text>No meetings scheduled for today.</Text>
                      }
                    />
                  </Flex>
                </>
              )}
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Flex
                align="center"
                justify="space-between"
                style={{ padding: "0 0 12px 0", minHeight: 44 }}
              >
                <Text strong>Votings</Text>
              </Flex>
              {votesLoading ? (
                <CommonSkeletonLoader
                  itemCount={
                    dashboardVotingList ? dashboardVotingList.length : 3
                  }
                />
              ) : dashboardVotingList && dashboardVotingList.length > 0 ? (
                <Suspense fallback={
                  <CommonSkeletonLoader itemCount={dashboardVotingList ? dashboardVotingList.length : 3} />
                }>
                  {
                    dashboardVotingList.map((singleVote, index) => (
                      <DashboardVotings
                        singleVote={singleVote}
                        index={index}
                        getTodayDashboadData={getTodayDashboadData}
                        sameVoteIndicated={sameVoteIndicated}
                        setSameVoteIndicated={setSameVoteIndicated}
                        votesLoading={votesLoading}
                        setVotesLoading={setVotesLoading}
                      />
                    ))
                  }
                </Suspense>
              ) : (
                <Flex
                  align="center"
                  justify="center"
                  style={{ minHeight: 300 }}
                >
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<Text>No voting for today.</Text>}
                  />
                </Flex>
              )}

              {/* <Badge.Ribbon text="Status" color='green'>
              <div style={{
                padding: '12px 16px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
                marginBottom: 8
              }}>
                <Flex vertical>
                  <Flex align='center' justify='space-between'>
                    <Flex vertical>
                      <Content>
                        <span style={{ fontWeight: 800 }}>Approve Budget</span>
                        <br />
                        <span style={{ fontSize: 14 }}>Board Meeting</span>
                        <br />
                        <span style={{ fontSize: 12, color: colorTextDescription }}>April 30, 2024 | 11.00AM - 11.30AM</span>
                      </Content>
                    </Flex>
                    <Flex align='center' justify='flex-end' gap={16}>
                      <Button type="text" icon={<MoreOutlined />} />
                    </Flex>
                  </Flex>
                  <Divider style={{ margin: '8px 0' }} />
                  <Flex align='center' justify='space-between'>
                    <Button type="text" icon={<LikeOutlined />} > 9 </Button>
                    <Button type="text" icon={<HistoryOutlined />} > 9 </Button>
                    <Button type="text" icon={<DislikeOutlined />} > 9 </Button>
                  </Flex>
                </Flex>

              </div>
            </Badge.Ribbon> */}
            </Col>
          </Row>
        )}
      </div>
      {contextHolder}
    </>
  );
}
